import axios from "../utils/request";

export default {
    getWebsiteDiscount(id) {
        return axios.get(`/website/list/${id}`)
    },
    getWebsiteSwiperTitle(id) {
        return axios.get(`/swiper/list/${id}`)
    }
}